import { Row, Money } from "./kit";

export const calcPricing = (p) => {
  const n = (v) => Number(v || 0);
  const tax = Math.round(n(p.subtotal) * n(p.tax_rate)) / 100;
  return {
    ...p,
    tax_amount: tax,
    total: n(p.subtotal) + tax,
    driven_remaining: n(p.subtotal) - n(p.parts_cost) - n(p.payout) - n(p.other_costs),
  };
};

export default function PricingBox({ p }) {
  const c = calcPricing(p);
  return (
    <div className="rounded-xl border border-[#262626] bg-[#0F0F0F] p-3" data-testid="admin-margin-calc">
      <Row k="Customer subtotal" v={<Money v={c.subtotal} />} />
      <Row k="− Actual parts / supplies" v={<Money v={c.parts_cost} />} />
      <Row k="− Specialist payout" v={<Money v={c.payout} />} />
      <Row k="− Other direct costs" v={<Money v={c.other_costs} />} />
      <div className="flex justify-between items-baseline border-t border-[#262626] mt-2 pt-2">
        <div>
          <div className="text-sm font-medium">Driven remaining</div>
          <div className="text-[11px] text-neutral-500">Before overhead and taxes</div>
        </div>
        <Money v={c.driven_remaining} green={c.driven_remaining >= 0} className={`text-2xl font-semibold ${c.driven_remaining < 0 ? "text-red-400" : ""}`} testid="driven-remaining" />
      </div>
      <div className="border-t border-dashed border-[#262626] mt-2 pt-2 text-xs text-neutral-500">
        <Row k={`Sales tax ${Number(c.tax_rate || 0)}% (collected separately)`} v={<Money v={c.tax_amount} testid="tax-amount" />} />
        <Row k="Customer total" v={<Money v={c.total} testid="customer-total" />} />
      </div>
    </div>
  );
}
